/**
 * The key to store appliance id into in a telemetry baggage header
 */
export const BAGGAGE_APPLIANCE_ID_KEY = "applianceId";

/**
 * The key to store teacher username into in a telemetry baggage header
 */
export const BAGGAGE_TEACHER_USERNAME_KEY = "teacherUsername";

/**
 * The key to store student username into in a telemetry baggage header
 */
export const BAGGAGE_STUDENT_USERNAME_KEY = "studentUsername";
